import Component from '../core/Component'
import substitute from '../utils/substitute'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class PlanBubble extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null
        }

        this.timer = null
    }

    prepare() {
        this.template = this.ref.content.innerHTML.trim()
    }

    show({x = 0, y = 0}) {
        this.element.style.left = `${x}px`
        this.element.style.top = `${y}px`
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
    }

    hide() {
        this.element.classList.remove(STATES.ACTIVE)
    }

    setContent(data = {}) {
        this.ref.content.innerHTML = substitute(this.template, data)
    }
}